import _ from 'lodash';
import {PROPERTY} from '../constants/actionTypes';
import initial from './initialState';

export default function (state = initial.propertyState, action) {
  switch (action.type) {
    case PROPERTY.GET_LIST_SUCCESS:
      return {...state, items: action.data.items || [], count: action.data.count || 0};
    case PROPERTY.RELOAD:
      return {...state, reload: !state.reload};
    case PROPERTY.GET_DETAIL_SUCCESS:
      return {...state, detail: action.data};
    case PROPERTY.RESET_DETAIL:
      return {...state, detail: {}};
    case PROPERTY.GET_KEY_SUCCESS: {
      let properties = _.cloneDeep(state.properties);
      if (!_.isEmpty(action.data) && action.data.key) {
        _.set(properties, action.data.key, action.data.values || []);
      }
      return {...state, properties: properties};
    }
    default:
      return state;
  }
}
